import React from 'react';
import PlanoDeDesenvolvimento from 'views/pages/PlanoDeDesenvolvimento.module.scss';

export const tabuleiro = [
  {
    title: '',
    urlImg:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18548.png',
    alt: 'Realize a sua 1ª venda de um plano anual com o seu cupom de Glampartner e ganhe um mimo.',
    details: (
      <img
        src={
          'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18548.png'
        }
        alt={'tabuleiro de plano de desenvolvimento'}
        Style="display:block; margin-left:auto; margin-right:auto"
      />
    ),
  },
];

export const concursosESorteios = [
  {
    title:
      'CONCURSO - Fique entre as top 3 Glampartners do mês em volume de vendas de assinaturas e ganhe prêmios!',
    urlImg:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22031.png',
    alt: 'CONCURSO - Fique entre as top 3 Glampartners do mês em volume de vendas de assinaturas e ganhe prêmios!',
    details: (
      <>
        <p>
          As 3 Glampartners com o maior número de vendas no mês ganham um
          presente incrível! Caprichem nas vendas e não percam a chance de
          garantir esse mimo 📽
        </p>

        <h3>Qual Glampartner vencerá?</h3>
        <p>
          As Glampartners que estiverem em 1º, 2º e 3º lugar do ranking de
          vendas durante o período de apuração.
        </p>
        <h3>Metodologia de apuração</h3>
        <p>
          1º lugar do ranking de vendas: maior valor em remuneração a ser paga
          durante o período de apuração.
        </p>
        <p>
          2º lugar do ranking de vendas: segundo maior valor em remuneração a
          ser paga durante o período de apuração.
        </p>
        <p>
          3º lugar do ranking de vendas: terceiro maior valor em remuneração a
          ser paga durante o período de apuração.
        </p>
        <p>
          Requisito mínimo para classificação: MÍNIMO de 5 assinaturas anuais.
          <br />
          1º critério de desempate: maior número de vendas de assinaturas
          anuais.
          <br />
          2º critério de desempate: maior número de vendas de assinaturas
          semestrais.
          <br />
          3º critério de desempate: maior número de vendas de assinaturas
          mensais.
          <br />
          4º critério de desempate: ganhará aquela que tiver efetuado a última
          venda primeiro.
        </p>

        <h3>Como saberei o resultado?</h3>

        <p>
          A vencedora será informada por e-mail e poderá acompanhar a live de
          divulgação do resultado que ocorre mensalmente no nosso perfil do
          Instagram (@glampartner).{' '}
        </p>

        <h3>Se eu ganhar o concurso, quando vou receber o brinde?</h3>
        <p>
          Você receberá o brinde na sua edição da Glambox de dois meses
          posteriores. Por exemplo, se você ganhar o concurso em janeiro,
          levantaremos esse resultado final em fevereiro e vamos solicitar a
          inclusão do seu mimo na próxima edição de março.
        </p>

        <h3>Tenho uma dúvida! Como faço para perguntar?</h3>
        <p>
          Você pode enviar um e-mail para{' '}
          <a
            className={PlanoDeDesenvolvimento['emailLink']}
            href="mailto:glampartners@glambox.com.br"
          >
            glampartners@glambox.com.br
          </a>
          !
        </p>
      </>
    ),
  },
  {
    title:
      'SORTEIO - Realizando uma venda de plano anual no mês, você já pode concorrer a um sorteio incrível de 10 kits de produtos!',
    urlImg:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22030.png',
    alt: 'SORTEIO - Realizando uma venda de plano anual no mês, você já pode concorrer a um sorteio incrível de 10 kits de produtos!',
    details: (
      <>
        <p>
          Sendo uma Glampartner, você tem a chance de concorrer a mimos fazendo
          um único uso de cupom para venda de plano anual da Glambox. Todos os
          meses, temos 10 ganhadoras. Está fácil demais participar, né? Garanta
          suas vendas e não perca essa chance!
        </p>
        <h3>Como concorrer?</h3>
        <p>
          Qualquer Glampartner que efetuar pelo menos uma venda anual durante o
          mês vigente estará automaticamente concorrendo. Não é necessária
          qualquer forma de aceitação formal.
        </p>

        <h3>Qual Glampartner vencerá?</h3>

        <p>
          Todas as Glampartners que realizarem ao menos uma venda anual no mês
          participarão do sorteio. Entre essas, serão sorteadas 10 Glampartners.
        </p>

        <h3>Como funcionará o sorteio e como saberei o resultado?</h3>
        <p>
          O sorteio acontecerá por meio de um sorteador online, com todos os
          nomes participantes durante a Live mensal que realizamos no Instagram{' '}
          <a href="https://www.instagram.com/glampartner/">@glampartner</a>. O
          resultado será divulgado ao vivo, em primeira mão e as vencedoras
          serão informadas sobre o resultado por e-mail.
        </p>

        <h3>Se eu for sorteada, quando vou receber o brinde?</h3>
        <p>
          Você receberá o brinde na sua edição da Glambox de dois meses
          posteriores. Por exemplo, se você ganhar o sorteio em janeiro,
          levantaremos o resultado em fevereiro e vamos solicitar a inclusão do
          seu mimo na próxima edição de março.
        </p>

        <h3>Tenho uma dúvida! Como faço para perguntar?</h3>
        <p>
          Você pode enviar um e-mail para{' '}
          <a
            className={PlanoDeDesenvolvimento['emailLink']}
            href="mailto:glampartners@glambox.com.br"
          >
            glampartners@glambox.com.br
          </a>
          !
        </p>
      </>
    ),
  },
  {
    title:
      'Faça 5 vendas do plano anual da Glambox com o seu cupom e ganhe um brinde exclusivo!',
    urlImg:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22028.png',
    alt: 'Faça 5 vendas do plano anual da Glambox com o seu cupom e ganhe um brinde exclusivo!',
    details: (
      <>
        <p>
          Você já percebeu que aqui no Programa Glampartners, mais um mimo nunca
          é demais, né? Por isso, queremos que você seja presenteada sempre!
        </p>
        <p>
          Ao realizar 5 usos de cupom para venda de plano anual da Glambox
          durante o mês vigente, você ganha um presente com a sua edição de dois
          meses posteriores. Por exemplo, se você fizer 5 vendas anuais em
          janeiro, levantaremos o seu resultado final em fevereiro e vamos
          solicitar a inclusão do seu mimo na próxima edição de março. Demais,
          né?
        </p>
        <p>Então corre já pra divulgar!</p>
      </>
    ),
  },
  {
    title:
      'Faça 2 vendas do plano anual da Glambox com o seu cupom e ganhe um brinde exclusivo!',
    urlImg:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_22027.png',
    alt: 'Faça 2 vendas do plano anual da Glambox com o seu cupom e ganhe um brinde exclusivo!',
    details: (
      <>
        <p>
          Seu cupom vale muito para quem usa, mas cada uso pode valer ainda mais
          para você! Sendo uma Glampartner, ao realizar 2 usos de cupom para
          venda de plano anual da Glambox durante o mês vigente, você ganha um
          presente com a sua edição de dois meses posteriores. Por exemplo, se
          você fizer 2 vendas anuais em janeiro, levantaremos o seu resultado
          final em fevereiro e vamos solicitar a inclusão do seu mimo na próxima
          edição de março.
        </p>
        <p>Incrível, né?</p>
        <p>Então corre já pra divulgar!</p>
      </>
    ),
  },
  {
    title:
      'Faça a sua 1ª venda com o seu cupom de Glampartner e ganhe um presente especial!',
    urlImg:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21172.png',
    alt: 'Faça a sua 1ª venda com o seu cupom de Glampartner e ganhe um presente especial!',
    details: (
      <>
        <p>
          Realizou a sua primeira venda com o cupom de Glampartner? Você merece
          um presente! ❤️
        </p>

        <p>
          Realizando essa conquista, vamos enviar um mimo na sua edição de dois
          meses posteriores. Por exemplo, se você realizar a primeira venda em
          janeiro, levantaremos o seu resultado final em fevereiro e vamos
          solicitar a inclusão do seu mimo na próxima edição de março.
        </p>
      </>
    ),
  },
  {
    title:
      'Realize a sua 1ª venda de um plano anual com o seu cupom de Glampartner e ganhe um mimo.',
    urlImg:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21173.png',
    alt: 'Realize a sua 1ª venda de um plano anual com o seu cupom de Glampartner e ganhe um mimo.',
    details: (
      <p>
        Realizando a sua primeira venda de plano anual da Glambox com o cupom de
        Glampartner, você tem direito a mais um incentivo! Vamos enviar um
        presentinho na sua edição de dois meses posteriores. Por exemplo, se
        você realizar a primeira venda anual em janeiro, levantaremos o seu
        resultado final em fevereiro e vamos solicitar a inclusão do seu mimo na
        próxima edição de março.
      </p>
    ),
  },
];
